export default "/images/priva-logo-black.png?a9012387e5369a86aa07565507b204a7";